module.exports = __webpack_public_path__ + "static/media/nexmarket.e3643a28.svg";